import gql from 'graphql-tag';
import ImageDataFragment from './ImageData.gql';

export default gql`
  fragment ContestEntryItemFragment on ContestEntryItem {
    id
    type
    data {
      submissionId
      title
      bracket {
        slug
        name
      }
      contestant {
        name
        city
        state
      }
      images {
        ...ImageDataFragment
      }
      sections {
        id
        title
        fields {
          fieldId
          name
          value
        }
      }
    }
  }
  ${ImageDataFragment}
`;
